/**
 * Parser format teks WhatsApp untuk pratinjau.
 * Mendukung *tebal*, _miring_, ~coret~, ```monospace```, dan baris baru.
 * Variabel ${...} dilindungi agar tidak ikut terformat.
 */

function escapeHtml(text) {
  return String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function formatWhatsAppText(text) {
  if (text === null || typeof text === "undefined" || text === "") {
    return "";
  }

  let html = escapeHtml(text);
  const codeTokens = [];
  const variableTokens = [];

  // Lindungi blok monospace agar isinya tidak ikut diproses sebagai markdown.
  html = html.replace(/```([\s\S]*?)```/g, (match, code) => {
    const token = "WAJOOCODETOKEN" + codeTokens.length + "X";
    codeTokens.push(
      '<code class="wa-format-code">' +
        code.replace(/\r?\n/g, "<br>") +
        "</code>"
    );
    return token;
  });

  // Lindungi variabel dinamis, misalnya ${first_name}.
  html = html.replace(/\$\{[^}]+\}/g, (match) => {
    const token = "WAJOOVARIABLETOKEN" + variableTokens.length + "X";
    variableTokens.push(match);
    return token;
  });

  html = html
    .replace(/\*([^\n*]+?)\*/g, "<strong>$1</strong>")
    .replace(/_([^\n_]+?)_/g, "<em>$1</em>")
    .replace(/~([^\n~]+?)~/g, "<del>$1</del>")
    .replace(/`([^`\n]+?)`/g, '<code class="wa-format-code">$1</code>');

  html = html.replace(/\r?\n/g, "<br>");

  codeTokens.forEach((code, index) => {
    html = html.replace("WAJOOCODETOKEN" + index + "X", code);
  });

  variableTokens.forEach((variable, index) => {
    html = html.replace("WAJOOVARIABLETOKEN" + index + "X", variable);
  });

  return html;
}

export default formatWhatsAppText;



// WEBPACK FOOTER //
// ./src/utils/whatsappFormat.js